import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "swiper/css";

const initHomeCasesSliders = () => {
    document.querySelectorAll('[data-home-cases-slider]').forEach((root) => {
    const section = root.closest('.cases');
    const navigation = section?.querySelector('[data-home-cases-navigation]');
    const previousButton = navigation?.querySelector('.home-cases-navigation__button--prev');
    const nextButton = navigation?.querySelector('.home-cases-navigation__button--next');
    const counter = navigation?.querySelector('[data-home-cases-counter]');
    const slides = root.querySelectorAll('.swiper-slide');

    if (slides.length < 2) {
        navigation?.setAttribute('hidden', 'hidden');
        return;
    }

    const updateCounter = (swiper) => {
        if (counter) {
            counter.textContent = `${String(swiper.realIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        }
    };

    const swiper = new Swiper(root, {
        modules: [A11y, Navigation],
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: Math.floor(slides.length / 2),
        spaceBetween: 16,
        slideToClickedSlide: true,
        speed: 420,
        watchSlidesProgress: true,
        navigation: {
            prevEl: previousButton,
            nextEl: nextButton,
        },
        a11y: {
            prevSlideMessage: 'Previous case',
            nextSlideMessage: 'Next case',
        },
        breakpoints: {
            1200: {
                spaceBetween: -72,
            },
        },
        on: {
            init: updateCounter,
            slideChange: updateCounter,
        },
    });

    updateCounter(swiper);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeCasesSliders, { once: true });
} else {
    initHomeCasesSliders();
}
